import { useFlags } from '@saucelabs/sl-util-launchdarkly';
import { useSelector } from 'react-redux';

import { GlobalState } from '../../../reducers';
import {
  constants as realDeviceSelectionConstants,
  records as realDeviceSelectionRecords,
} from '../../realDeviceSelection';
import { selectors as testConfigurationSelectors } from '../../testConfiguration';
import constants from '../constants';

const useIsWebRtcSupported = (): boolean => {
  const flags = useFlags();
  const realDeviceConfiguration = useSelector<
    GlobalState, realDeviceSelectionRecords.DeviceDescriptor
  >(testConfigurationSelectors.realDeviceConfigurationSelector);

  let isInFeatureFlag = false;

  if (realDeviceConfiguration?.os === realDeviceSelectionConstants.MOBILE_PLATFORMS.ANDROID) {
    isInFeatureFlag = (flags?.[constants.WEB_RTC_ANDROID_FEATURE_FLAG_NAME] ?? false) as boolean;
  }

  if (realDeviceConfiguration?.os === realDeviceSelectionConstants.MOBILE_PLATFORMS.IOS) {
    isInFeatureFlag = (flags?.[constants.WEB_RTC_IOS_FEATURE_FLAG_NAME] ?? false) as boolean;
  }

  return isInFeatureFlag && (realDeviceConfiguration?.isWebRtcSupported() ?? false);
};

export {
  useIsWebRtcSupported,
};
